<section class="py-4">
    <div class="container">
      <div class="row justify-content-center">
        <!-- Google Play -->
        <div class="col-6 col-sm-4 col-md-3 mb-3">
          <a
            href="https://play.google.com/store/apps/details?id=ceo.optionmatrix.com.xp&pli=1"
            class="d-block text-center" target="_blank"
          >
            <img
              src="assets/Icon/google-play.svg"
              alt="Download from Google Play"
              class="img-fluid"
            />
          </a>
        </div>
        <!-- App Store -->
        <div class="col-6 col-sm-4 col-md-3 mb-3">
          <a
            href="https://apps.apple.com/us/app/xp360-customer/id6468776747"
            class="d-block text-center" target="_blank"
          >
            <img
              src="assets/Icon/app-store.svg"
              alt="Download from App Store"
              class="img-fluid"
            />
          </a>
        </div>
      </div>
    </div>
  </section>
  